import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("../pages/home/page"));
const BlogPage = lazy(() => import("../pages/blog/page"));
const CalculatorPage = lazy(() => import("../pages/calculator/page"));
const NotFound = lazy(() => import("../pages/NotFound"));

// Individual calculator pages
const IncomeTaxCalculator = lazy(() => import("../pages/calculator/components/IncomeTaxCalculator"));
const DeductionFinder = lazy(() => import("../pages/calculator/components/DeductionFinder"));
const RefundCalculator = lazy(() => import("../pages/calculator/components/RefundCalculator"));
const W2vs1099Comparison = lazy(() => import("../pages/calculator/components/W2vs1099Comparison"));
const SelfEmploymentTax = lazy(() => import("../pages/calculator/components/SelfEmploymentTax"));
const CapitalGainsCalculator = lazy(() => import("../pages/calculator/components/CapitalGainsCalculator"));
const QuarterlyTaxEstimator = lazy(() => import("../pages/calculator/components/QuarterlyTaxEstimator"));
const WithholdingCalculator = lazy(() => import("../pages/calculator/components/WithholdingCalculator"));
const RetirementContribution = lazy(() => import("../pages/calculator/components/RetirementContribution"));
const StateTaxComparison = lazy(() => import("../pages/calculator/components/StateTaxComparison"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogPage />,
  },
  {
    path: "/calculator",
    element: <CalculatorPage />,
  },
  {
    path: "/calculator/income-tax",
    element: <IncomeTaxCalculator />,
  },
  {
    path: "/calculator/deduction-finder",
    element: <DeductionFinder />,
  },
  {
    path: "/calculator/refund",
    element: <RefundCalculator />,
  },
  {
    path: "/calculator/w2-vs-1099",
    element: <W2vs1099Comparison />,
  },
  {
    path: "/calculator/self-employment",
    element: <SelfEmploymentTax />,
  },
  {
    path: "/calculator/capital-gains",
    element: <CapitalGainsCalculator />,
  },
  {
    path: "/calculator/quarterly-tax",
    element: <QuarterlyTaxEstimator />,
  },
  {
    path: "/calculator/withholding",
    element: <WithholdingCalculator />,
  },
  {
    path: "/calculator/retirement",
    element: <RetirementContribution />,
  },
  {
    path: "/calculator/state-comparison",
    element: <StateTaxComparison />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;